export class FlightShoppingSortFormModel {
  constructor(type, order) {
    //排序类型，可为PRICE，DURATION，DEPARTURE，ARRIVAL
    this.type = type;
    //升序降序，可为ASC-升序，DSC-降序
    this.order = order;
  }
}
